/* eslint-disable @typescript-eslint/naming-convention */

export interface IIrctcPayload {
    encoded_payload: string;
    coach?: string;
    berth?: string;
    station_name?: string;
    platform_number?: string;
    mobile_number?: string;
    pnr_number?: string;
    train_name?: string;
    train_number?: string;
    train_start_date?: string; // YYYY-MM-DD
    source_station_code?: string;
}

export interface IIrctcInfo {
    presentation_info?: IIrctcPresentationInfo;
    non_pnr?: IIrctcNonPnr;
    pnr_tool_tip_data?: IIrctcPnrToolTipData;
}

export interface IIrctcNonPnr {
    non_pnr?: string;
    title: string;
    sub_title: string;
    input_placeholder: string;
    cta: string;
}

export interface IIrctcPresentationInfo {
    widget_image: string;
    background: string;
}

export interface IIrctcPnrToolTipData {
    text: string;
    icon?: string;
}

export interface IIrctcTrainOrderAttributes {
    train_number: string;
    train_name: string;
}

export interface IIrctcNonPnrHalfcardData {
    title: string;
    sub_title: string;
    input_placeholder: string;
    cta: string;
}

export enum IrctcAddressChangeFormKeys {
    COACH_NO = "coachNo",
    SEAT_NO = "seatNo",
    CONTACT_NO = "contactNo",
}
